document.addEventListener("click", (evt) => {
  const copyButton = evt.target.closest(".copy-btn");
  if (!copyButton) return;
  evt.preventDefault();
  evt.stopPropagation();

  const isQuickView = !!copyButton.closest(".quick-add-modal");
  const btnUrlToCopy = copyButton.getAttribute("href");
  const btnCopiedText = copyButton.getAttribute("data-copied-text");
  const urlToCopy = isQuickView && btnUrlToCopy ? btnUrlToCopy : window.location.href;
  const nameSpan = copyButton.querySelector(".share-button__name");
  const originalText = nameSpan ? nameSpan.textContent.trim() : "";

  navigator.clipboard.writeText(urlToCopy)
    .then(() => {
      if (!nameSpan) return;
      clearTimeout(copyButton._copyResetTimeout);
      nameSpan.textContent = btnCopiedText || "Copied";
      copyButton._copyResetTimeout = setTimeout(() => {
        nameSpan.textContent = originalText;
      }, 2000);
    })
    .catch((err) => console.error("Copy failed:", err));
});